export class GChartSerieLabel {
  formatter?: string | Function;

  constructor(init?: Readonly<GChartSerieLabel>) {
    Object.assign(this, init);
  }
}
